<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="w-full">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('system.label.ProvisioningDevice')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="hardwareMappingList"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.ProvisioningDevice") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push('/createDevice').catch(() => {})"
                      size="small"
                      >{{ $t("system.label.Create") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("system.label.ItemClass") }}</vs-th>
                  <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("system.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="hardwareMappingList"
                    v-for="(hardwareMappingList, index) in data"
                  >
                    <vs-td :data="hardwareMappingList.itemClassName">{{
                      hardwareMappingList.itemClassName
                    }}</vs-td>
                    <vs-td :data="hardwareMappingList.provisioningValue">{{
                      hardwareMappingList.provisioningValue
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('system.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editCreateDevice(hardwareMappingList.id)"
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('system.label.ProvisionCommand')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="provisioningList"
                :description="false"
                @selected="handleSelected"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.ProvisionCommand") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push('/createCommand').catch(() => {})"
                      size="small"
                      >{{ $t("system.label.Create") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
                  <vs-th>{{ $t("system.label.CommandName") }}</vs-th>
                  <vs-th>{{ $t("system.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("system.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="provisioningList"
                    v-for="(provisioningList, index) in data"
                  >
                    <vs-td :data="provisioningList.provisioningSystemName">{{
                      provisioningList.provisioningSystemName
                    }}</vs-td>
                    <vs-td :data="provisioningList.commandName">{{
                      provisioningList.commandName
                    }}</vs-td>
                    <vs-td :data="provisioningList.status">{{
                      provisioningList.status
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          :title="$t('system.label.View')"
                          icon="EyeIcon"
                          @click="handleSelected(provisioningList)"
                          svgClasses="w-5 h-5 stroke-current text-primary"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('system.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editCreateCommand(provisioningList.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('system.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          class="icon_row"
                          @click.stop="
                            deleteProvisioningPopup = true;
                            delId = provisioningList.id;
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('system.label.ProvisioningActions')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="provisioningActionsList"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.ProvisioningActions") }}
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("system.label.ProvisionType") }}</vs-th>
                  <vs-th>{{ $t("system.label.Action") }}</vs-th>
                  <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
                  <vs-th>{{ $t("system.label.IsEnable") }}</vs-th>
                  <vs-th>{{ $t("system.label.Action") }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="provisioningActionsList"
                    v-for="(provisioningActionsList, index) in data"
                  >
                    <vs-td :data="provisioningActionsList.provisionType">{{
                      provisioningActionsList.provisionType
                    }}</vs-td>
                    <vs-td :data="provisioningActionsList.action">{{
                      provisioningActionsList.action
                    }}</vs-td>
                    <vs-td :data="provisioningActionsList.provisioningSystem">{{
                      provisioningActionsList.provisioningSystem
                    }}</vs-td>
                    <vs-td :data="provisioningActionsList.isEnable">{{
                      provisioningActionsList.isEnable === "Y" ? "Y" : "N"
                    }}</vs-td>
                    <vs-td>
                      <vs-switch
                        :checked="
                          isEnableSwitch(provisioningActionsList.isEnable)
                        "
                        @change="toggleSwitch(provisioningActionsList)"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('system.label.NetworkSystem')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="networkElementList"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.NetworkSystem") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push('/createSystem').catch(() => {})"
                      size="small"
                      >{{ $t("system.label.Create") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("system.label.SystemCode") }}</vs-th>
                  <vs-th>{{ $t("system.label.SystemName") }}</vs-th>
                  <vs-th>{{ $t("system.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("system.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="networkElementList"
                    v-for="(networkElementList, index) in data"
                  >
                    <vs-td :data="networkElementList.systemcode">{{
                      networkElementList.systemcode
                    }}</vs-td>
                    <vs-td :data="networkElementList.systemname">{{
                      networkElementList.systemname
                    }}</vs-td>
                    <vs-td :data="networkElementList.status">{{
                      networkElementList.status
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('system.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editCreatesystem(networkElementList.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('system.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          class="icon_row"
                          @click.stop="
                            deletePopup = true;
                            delId = networkElementList.id;
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('system.label.DeleteNetworkSystem')"
          :active.sync="deletePopup"
        >
          <div class="vx-row centerx md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                {{ $t("system.label.AreYouSure") }}
              </div>
            </div>
          </div>

          <div class="vx-row centerx">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="deletePopup = false">{{
                $t("system.label.cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteCurrencyData(delId)" color="warning">{{
                $t("system.label.ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('system.label.DeleteProvisionCommand')"
          :active.sync="deleteProvisioningPopup"
        >
          <div class="vx-row centerx md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                {{ $t("system.label.AreYouSure") }}
              </div>
            </div>
          </div>

          <div class="vx-row centerx">
            <span class="ml-4 mr-1">
              <vs-button
                type="border"
                @click="deleteProvisioningPopup = false"
                >{{ $t("system.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteProvisionData(delId)" color="warning">{{
                $t("system.label.ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      deleteProvisioningPopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapGetters({
      hardwareMappingList: "provisioningConfig/gethardwaresList",
      provisioningList: "provisioningConfig/getcommandList",
      provisioningActionsList: "provisioningConfig/getprovisioningActionList",
      networkElementList: "provisioningConfig/getnetworkSystemList",
    }),
  },
  methods: {
    async getDeviceData() {
      this.loading = true;
      try {
        this.$store.dispatch("provisioningConfig/sethardwaremappingData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getCommandData() {
      this.loading = true;
      try {
        this.$store.dispatch("provisioningConfig/setprovisioningData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getActionsData() {
      this.loading = true;
      try {
        this.$store.dispatch("provisioningConfig/setprovisioningActionsData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getSystemData() {
      this.loading = true;
      try {
        this.$store.dispatch("provisioningConfig/setnetworkelementData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteCurrencyData(id) {
      try {
        await this.$store.dispatch(
          "provisioningConfig/setDeletenetworkElement",
          id
        );
        this.getSystemData();
        this.deletePopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteProvisionData(id) {
      try {
        await this.$store.dispatch(
          "provisioningConfig/deleteProvisioningCommand",
          id
        );
        this.getCommandData();
        this.deleteProvisioningPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editCreateDevice(id) {
      this.$router.push(`/editCreateDevice/${id}`);
    },
    editCreatesystem(id) {
      this.$router.push(`/editCreateSystem/${id}`);
    },
    editCreateCommand(id) {
      this.$router.push(`/editCreateCommand/${id}`);
    },
    isEnableSwitch(isEnable) {
      return isEnable === "Y";
    },

    async toggleSwitch(provisioningActionsList) {
      try {
        // Toggle the isEnable value
        const updatedIsEnable =
          provisioningActionsList.isEnable === "Y" ? "N" : "Y";
        await this.updateProvisioningActions(provisioningActionsList.id, {
          isEnable: updatedIsEnable,
          status: updatedIsEnable === "Y" ? "true" : "false",
        });
        provisioningActionsList.isEnable = updatedIsEnable;
      } catch (error) {
        console.error("Error updating provisioningActions:", error);
      }
    },

    async updateProvisioningActions(id, payload) {
      try {
        await this.$store.dispatch(
          "provisioningConfig/updateProvisioningActionsAction",
          { id: id, data: payload }
        );
      } catch (error) {
        console.error("Error updating provisioningActions:", error);
        throw error;
      }
    },
    handleSelected(provisioningList) {
      this.$router.push({
        path: `/viewProvisioningMapping/${provisioningList.id}`,
      });
    },
  },
  mounted() {
    this.getDeviceData();
    this.getCommandData();
    this.getActionsData();
    this.getSystemData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
</style>
